import f, { StrictMode as m, Suspense as x } from "react";
import { SnackProvider as j, NavStateProvider as y, MediaStateProvider as _, MainContainer as a, PageContainer as h, Loader as u } from "@reapit/elements";
import { QueryClient as v, QueryClientProvider as P } from "@tanstack/react-query";
import { ErrorBoundary as R } from "@reapitform/utils";
import { useReapitConnect as S } from "@reapit/connect-session";
import { reapitConnectBrowserSession as C } from "@reapitform/hooks";
import { useLocation as k, redirect as O, Outlet as E } from "react-router";
var d = { exports: {} }, s = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var g = f, w = Symbol.for("react.element"), b = Symbol.for("react.fragment"), B = Object.prototype.hasOwnProperty, L = g.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, q = { key: !0, ref: !0, __self: !0, __source: !0 };
function p(t, e, o) {
  var n, i = {}, c = null, l = null;
  o !== void 0 && (c = "" + o), e.key !== void 0 && (c = "" + e.key), e.ref !== void 0 && (l = e.ref);
  for (n in e) B.call(e, n) && !q.hasOwnProperty(n) && (i[n] = e[n]);
  if (t && t.defaultProps) for (n in e = t.defaultProps, e) i[n] === void 0 && (i[n] = e[n]);
  return { $$typeof: w, type: t, key: c, ref: l, props: i, _owner: L.current };
}
s.Fragment = b;
s.jsx = p;
s.jsxs = p;
d.exports = s;
var r = d.exports;
const I = new v(), G = (t) => /* @__PURE__ */ r.jsx(m, { children: /* @__PURE__ */ r.jsx(P, { client: t.queryClient || I, children: /* @__PURE__ */ r.jsx(R, { children: /* @__PURE__ */ r.jsx(j, { children: /* @__PURE__ */ r.jsx(y, { children: /* @__PURE__ */ r.jsx(_, { children: t.children }) }) }) }) }) }), Q = () => {
  const { connectSession: t, connectInternalRedirect: e } = S(C), o = k();
  return t ? (e && o?.pathname !== e && O(e), /* @__PURE__ */ r.jsx(a, { hasGreyBackground: !0, children: /* @__PURE__ */ r.jsx(x, { fallback: /* @__PURE__ */ r.jsx(u, { fullPage: !0 }), children: /* @__PURE__ */ r.jsx(E, {}) }) })) : /* @__PURE__ */ r.jsx(a, { hasGreyBackground: !0, children: /* @__PURE__ */ r.jsx(h, { children: /* @__PURE__ */ r.jsx(u, { fullPage: !0 }) }) });
};
export {
  G as MainAppRender,
  Q as PrivateRouteWrapper,
  I as queryClient
};
